import { useDeletePresetMutationApi } from '@aibees/shared/api';
import { IconType } from '@aibees/shared/components';
import { useNotify } from '@aibees/shared/hooks';
import { random } from 'lodash-es';
import { useTableLayoutTemplateContext } from '../context';

export function useDeleteTemplateItem(
  id?: string,
  deleteNotificationTitle?: string,
  deleteNotificationDescription?: string,
  deleteNotificationIcon?: IconType
) {
  const notify = useNotify();
  const { mutateAsync, isLoading } = useDeletePresetMutationApi(id);
  const { refetchTemplates } = useTableLayoutTemplateContext();

  const handleDelete = () => {
    mutateAsync({})
      .then(() => {
        notify.complete(
          deleteNotificationTitle,
          deleteNotificationDescription,
          random(1, 1000000),
          {
            icon: deleteNotificationIcon!,
          }
        );
      })
      .finally(() => {
        refetchTemplates();
      });
  };

  return { handleDelete, isLoading };
}
